import { ComponentBase } from "@tblabs/truffle";


export class Nav extends ComponentBase<HTMLElement>
{
    constructor(className: string)
    {
        super("nav");
        this.Class(className);
    }
}
